const SpringTypes = {
  FETCH_SPRING_TIMING_BP_OBJECT: 'FETCH_SPRING_TIMING_BP_OBJECT',
  REMOVE_SPRING_TIMING_BP_OBJECT: 'REMOVE_SPRING_TIMING_BP_OBJECT',

  FETCH_SPRING_MAGNITUDE_BP_OBJECT: 'FETCH_SPRING_MAGNITUDE_BP_OBJECT',
  REMOVE_SPRING_MAGNITUDE_BP_OBJECT: 'REMOVE_SPRING_MAGNITUDE_BP_OBJECT',
};

export default SpringTypes;



// WEBPACK FOOTER //
// ./src/action-types/spring.js